var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.66683H14M5.33333 4.00016V1.3335M10.6667 4.00016V1.3335M6.26667 14.6668H9.73333C11.2268 14.6668 11.9735 14.6668 12.544 14.3762C13.0457 14.1205 13.4537 13.7126 13.7094 13.2108C14 12.6404 14 11.8936 14 10.4002V6.9335C14 5.44002 14 4.69329 13.7094 4.12285C13.4537 3.62109 13.0457 3.21314 12.544 2.95748C11.9735 2.66683 11.2268 2.66683 9.73333 2.66683H6.26667C4.77319 2.66683 4.02646 2.66683 3.45603 2.95748C2.95426 3.21314 2.54631 3.62109 2.29065 4.12285C2 4.69329 2 5.44002 2 6.9335V10.4002C2 11.8936 2 12.6404 2.29065 13.2108C2.54631 13.7126 2.95426 14.1205 3.45603 14.3762C4.02646 14.6668 4.77319 14.6668 6.26667 14.6668Z",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/date-picker.b5ea733ababf0a67cc2d81843d406682.svg";
export { ForwardRef as ReactComponent };